import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import RequiemNoir from './demos/RequiemNoir/index.jsx';
import CookieConsent from './components/CookieConsent.jsx';

function LangSync() {
  const { i18n } = useTranslation();
  const { pathname } = useLocation();
  useEffect(() => {
    const wantGr = pathname.startsWith('/el');
    const target = wantGr ? 'gr' : 'en';
    if (i18n.language !== target) i18n.changeLanguage(target);
    document.documentElement.lang = wantGr ? 'el' : 'en';
  }, [pathname, i18n]);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <LangSync />
      <Routes>
        <Route path="/el/*" element={<RequiemNoir variant="atelier" />} />
        <Route path="*" element={<RequiemNoir variant="atelier" />} />
      </Routes>
      <CookieConsent />
    </BrowserRouter>
  );
}
